import { Component, Input, OnInit } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() imageUrl = '../../../assets/img/logo-suafaculdade.png'

  isIframe: boolean = this.baseService.onCheckIframe();

  constructor(private baseService: BaseService) { }

  ngOnInit(): void { }


}
